<div>
  <div [formGroup]="form" class="pb-2">
    <mat-form-field class="w-full">
      <mat-label>Task Types</mat-label>
      <mat-select
        formControlName="taskTypesSelection"
        multiple
        panelWidth="auto"
      >
        @for (taskType of allowedTaskTypes(); track taskType.value) {
          <mat-option [value]="taskType.value">
            @if (taskType.value === taskTypes.CreatePackageTaskItem) {
              <mat-icon fontSet="material-symbols-outlined">edit_document</mat-icon>
            } @else if (taskType.value === taskTypes.CallPayerTaskItem) {
              <mat-icon fontSet="material-symbols-outlined">call</mat-icon>
            } @else if (taskType.value === taskTypes.MailPackageTaskItem) {
              <mat-icon fontSet="material-symbols-outlined">mail</mat-icon>
            } @else if (taskType.value === taskTypes.ReviewTaskItem) {
              <mat-icon fontSet="material-symbols-outlined">menu_book</mat-icon>
            }
            {{ taskType.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <!-- List of completed tasks -->
  <ri-resolution-ui-lazy-load-container
    [hasMoreItems]="hasGroupsToFetch()"
    (loadMoreItems)="loadTaskGroups()"
  >
    <ri-resolution-ui-sidebar-flat-tasks-list
      [tasks]="flatTasksList()"
    ></ri-resolution-ui-sidebar-flat-tasks-list>

    <ng-template #message>
      <div class="p-3 text-center text-sm text-gray-500">
        @if (isLoading()) {
          Loading...
        } @else if (hasTasksLessThanLimit() && !hasGroupsToFetch()) {
          No additional tasks
        } @else if (hasNoTasks()) {
          No Tasks
        } @else if (!hasGroupsToFetch()) {
          No more tasks to load
        }
      </div>
    </ng-template>
  </ri-resolution-ui-lazy-load-container>
</div>
